import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import { getArticleURL } from '../../../../catalog/Social';
import { getWebsiteImage } from '../../../../catalog/Website';
import { getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';

const ArticleTags = (props) => {
    const { id, title, articleTime, featureImage, writerName } = props;
    const { globalState } = useContext(context);

    const getImage = () => {
        if (isValidString(featureImage)) {
            return featureImage;
        } if (isValidObject(getWebsiteImage(globalState, 'articleFeatureImage'))) {
            return getWebsiteImage(globalState, 'articleFeatureImage');
        }
        return '';
    };

    const getArticleTime = () => {
        return getLocalTimeFromDatabaseTime(articleTime).toISOString();
    };

    return (
        <Helmet>
            {isValidString(title) && isValidObject(globalState) && isValidObject(globalState.accountObject) && isValidString(globalState.accountObject.url) ? (
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Articles",
                                "item": "${globalState.accountObject.url}/articles"
                            },{
                                "@type": "ListItem",
                                "position": 2,
                                "name": "${title.replace(/['"]+/g, '')}"
                            }]
                        }
                `}
                </script>
            ) : null}
            {isValidString(id) && isValidString(title) && isValidString(getImage()) && isValidString(writerName) && isValidObject(globalState) && isValidObject(globalState.accountObject) && isValidString(globalState.accountObject.url) && isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "NewsArticle",
                            "mainEntityOfPage": {
                                "@type": "WebPage",
                                "@id": "${getArticleURL(globalState, id)}"
                            },
                            "headline": "${title.replace(/['"]+/g, '')}",
                            "image": [
                                "${getImage()}"
                            ],
                            "datePublished": "${getArticleTime()}",
                            "dateModified": "${getArticleTime()}",
                            "author": {
                                "@type": "Person",
                                "name": "${writerName}"
                            },
                            "publisher": {
                                "@type": "Organization",
                                "name": "OptimX Sports",
                                "logo": {
                                    "@type": "ImageObject",
                                    "url": "${globalState.logo.logo2}"
                                }
                            }
                        }
                `}
                </script>
            ) : null}
        </Helmet>
    );
};

ArticleTags.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    articleTime: PropTypes.any.isRequired,
    featureImage: PropTypes.string.isRequired,
    writerName: PropTypes.string.isRequired,
};

export default memo(ArticleTags);
